export default function CapabilityMarquee() {
  const items = [
    "Curriculum Engineering",
    "Retrieval Augmented",
    "Adaptive Pacing",
    "AI-Native Content",
    "Parental Trust",
    "Built in India",
    "Global Mindset",
    "Outcome Driven",
  ];
  const loop = items.concat(items);
  return (
    <section
      data-testid="capability-marquee"
      className="relative overflow-hidden border-y border-neutral-200 bg-[#0A0A0A] py-5"
    >
      <div className="overflow-hidden">
        <div className="ct-marquee-track flex w-max items-center gap-12 whitespace-nowrap font-display text-sm uppercase tracking-[0.22em] text-neutral-400">
          {loop.map((t, i) => (
            <span key={i} className="flex items-center gap-12">
              {t}
              <span className="h-1 w-1 rounded-full bg-neutral-600" />
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
